/**
 * 课程筛选结果
 */
export default {
  loadMoreButtonName: 'もっと読み込み',
  errorNotice: '読み込みに失敗しました。再試行してください',
  emptyNotice: 'このカテゴリのコースはありません。他の学年・年のコースを見る',
}
